export default "__VITE_PUBLIC_ASSET__751ebd78__"